import API from '../api/api'

export const GET_COMMUNICATE_HISTORY = 'GET_COMMUNICATE_HISTORY'
export const SET_HISTORY = 'SET_HISTORY'
export const SET_COMMUNICATE_LOADING = 'SET_COMMUNICATE_LOADING'

export const initialState = {
  history: [],
  loadedAllHistory: false,
  loadingHistory: false,
}

const removeDuplic = (arr) => {
  const tempArr = []
  return arr
    .map((obj) => {
      if (!tempArr.includes(obj.id)) {
        tempArr.push(obj.id)
        return obj
      } else {
        return undefined
      }
    })
    .filter((x) => x)
}

const communicationPortalReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_COMMUNICATE_HISTORY:
      return {
        ...state,
        history: removeDuplic(action.history),
        loadedAllHistory: action.loadedAllHistory,
        loadingHistory: false,
      }
    case SET_HISTORY:
      return {
        ...state,
        history: action.history,
      }
    case SET_COMMUNICATE_LOADING:
      return {
        ...state,
        loadingHistory: action.loadingHistory,
      }
    default:
      return state
  }
}

// Actions
export const getCommunicationPortalHistoryWithCount = (
  page = 1,
  buildingId = 0,
  query = '',
  pageSize = 50,
  types = [],
  status,
  dateRange,
) => {
  const start = (page - 1) * pageSize
  return function (dispatch) {
    return API.getCommunicationPortalHistoryWithCount(
      start,
      pageSize,
      buildingId,
      query,
      types,
      status,
      dateRange,
    )
      .then((historyData) => {
        dispatch({
          type: GET_COMMUNICATE_HISTORY,
          history: historyData.data.history,
          loadedAllHistory: historyData.data.history.length < pageSize,
        })
        return Promise.resolve(historyData.data)
      })
      .catch((err) => {
        dispatch(setLoading(false))
        throw new Error(err)
      })
  }
}

export const setLoadingState = (loadingHistory) => {
  return function (dispatch) {
    dispatch(setLoading(loadingHistory))
  }
}

export const setHistory = (history) => {
  return {
    type: SET_HISTORY,
    history,
  }
}

const setLoading = (loadingHistory) => {
  return {
    type: SET_COMMUNICATE_LOADING,
    loadingHistory,
  }
}

// Selectors
export const selectCommunicationPortalHistory = (state) => state.communicationPortal.history

export const selectStatusOfLoading = (state) => state.communicationPortal.loadingHistory

export const selectStatusIsLoadedAll = (state) => state.communicationPortal.loadedAllHistory

export default communicationPortalReducer
